export const dashboardWidgets = {
  upcoming: {
    title: "Upcoming arrivals",
    empty: "No upcoming events",
    createBooking: "Create booking",
  },
  lastActivity: {
    title: "Latest activity",
  },
  portals: {
    title: "Synced booking channels",
    connectedSuccess: "Connected successfully",
    unknownChannel: "Unknown",
    connectNewChannel: "Connect a new channel",
    empty: "You have no synced channels",
    connectChannel: "Connect a channel",
    loadError: "The portals could not be loaded",
    errorTitle: "Error",
  },
};
